import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';
import { MenuOrderComponent } from './menu-order/menu-order.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LocalOrderListComponent } from './local-order-list/local-order-list.component';
import { StopPropagationDirective } from './stop-propagation.directive';
import { AppUpdateDialogBoxComponent } from './app-update-dialog-box/app-update-dialog-box.component';
import { AutofocusDirective } from './autofocus.directive';



@NgModule({
  declarations: [
    RecaptchaComponent,
    MenuOrderComponent,
    LocalOrderListComponent,
    StopPropagationDirective,
    AppUpdateDialogBoxComponent,
    AutofocusDirective
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatGridListModule,
    MatTabsModule,
    MatCardModule,
    FlexLayoutModule,
    MatBadgeModule,
    MatCheckboxModule
  ],
  exports: [
    RecaptchaComponent,
    MenuOrderComponent,
    MatToolbarModule,
    MatGridListModule,
    LocalOrderListComponent,
    StopPropagationDirective,
    AppUpdateDialogBoxComponent,
  ]
})
export class SharedModule { }
